import React from "react";
import { FileBox } from "./FileBox.jsx";
import { AutoTextBox } from "./AutoTextBox.jsx";
import * as cls from "./Form.module.scss";
export { FormTXT2 };
/**
 * Генератор простых форм по текстовому шаблону.
 *
 * Для указания поля ввода текста используйте тройное подчеркивание ___,
 * для указания места прикрепления файла используйте тройной амперсанд &&&.
 *
 * @property {Object} props - Атрибуты элемента.
 * @property {string} props.name - Префикс имён для полей формы.
 * @property {string} props.text - Текстовый шаблон формы.
 * @property {DataHandler} props.onChange - Обработчик изменения полей.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class FormTXT2 extends React.Component {
  paragraphs = [];
  constructor(props) {
    super(props);
    const parsed = this.parse(props.text);
    this.state = {
      fields: {
        ...parsed,
        ...(props.value || {}),
      },
    };
    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
  }
  setFields(fields) {
    this.setState({ fields: fields });
    if (this.props.onChange) this.props.onChange(fields);
  }
  updateField(id, value) {
    this.setFields({
      ...this.state.fields,
      [id]: value,
    });
  }
  componentDidMount() {
    if (this.props.onChange) this.props.onChange(this.state.fields);
  }
  componentDidUpdate(prevProps) {
    if (this.props.text !== prevProps.text)
      this.setFields(this.parse(this.props.text));
  }
  onChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.updateField(name, value);
  }
  onChangeFile(event) {
    const name = event.target.name;
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => this.updateField(name, event.target.result);
      reader.readAsDataURL(file);
    } else {
      this.updateField(name, "");
    }
  }
  parse(text) {
    const state = {};
    const lines = text.split("\n").filter((p) => p.trim() !== "");
    this.paragraphs = lines.map((line, line_index) => {
      const id = `${this.props.name}_${line_index}`;
      const node_list = line.split(/(___|&&&)/);
      let label = undefined;
      for (const node of node_list) {
        switch (node) {
          case "___":
            state[id] = "";
            return { type: "text", id, label };
          case "&&&":
            state[id] = "";
            return { type: "file", id, label };
          default:
            if (label) label += " " + node;
            else label = node;
        }
      }
      return { type: "label", id, text: label };
    });
    return state;
  }
  /**
   * Отображает компонент.
   * @returns {JSX.Element} Элемент JSX.
   */
  render() {
    console.debug("FormTXT2:", this.paragraphs);
    return (
      <div className={cls.form + " " + cls.form_layout_column}>
        {this.paragraphs.map((p) => this.renderNode(p))}
      </div>
    );
  }
  renderNode(node) {
    switch (node.type) {
      case "text":
        return (
          <AutoTextBox
            key={node.id}
            id={node.id}
            label={node.label}
            required={true}
            value={this.state.fields[node.id]}
            onChange={this.onChangeText}
          />
        );
      case "file":
        return (
          <FileBox
            key={node.id}
            id={node.id}
            label={node.label}
            required={true}
            checked={this.state.fields[node.id]}
            onChange={this.onChangeFile}
          />
        );
      case "label":
        return <p key={node.id}>{node.text}</p>;
      default:
        return <mark key={node.id}>{JSON.stringify(node)}</mark>;
    }
  }
}
